import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';

/**
 * The visible pre-publication marker.
 *
 * Anything wrapped here is an unverified business claim. The marker is
 * deliberately obtrusive so nothing can ship unnoticed, and every wrapped field
 * also appears in the administrator Pre-launch Review queue.
 */
export function Placeholder({
  children,
  note,
  onDark,
  inline
}: {
  children: React.ReactNode;
  note?: string;
  onDark?: boolean;
  inline?: boolean;
}) {
  if (inline) {
    return <span className={`inline border-b border-dashed border-gold-600 ${onDark ? 'text-gold-200' : 'text-gold-700'}`} title={note ?? 'Placeholder — review before publication'} data-id="element-551" data-mp="lsz86zfmr2a6">
        {children}
        <span className="sr-only" data-id="element-552" data-mp="bxe3uun39px9"> (placeholder — review before publication)</span>
      </span>;
  }
  return <div className={`relative border border-dashed border-gold-600 px-4 pt-7 pb-4 ${onDark ? 'bg-navy-800/60' : 'bg-gold-100/40'}`} data-id="element-553" data-mp="6yue0j5djtzm">
      <span className={`absolute -top-px left-0 inline-flex items-center gap-1.5 px-2 py-0.5 font-sans text-micro uppercase tracking-[0.12em] ${onDark ? 'bg-gold-600 text-ink' : 'bg-gold-600 text-white'}`} data-id="element-554" data-mp="3beq8b0tpribb">
        <AlertTriangleIcon aria-hidden="true" className="h-3 w-3" data-id="element-555" data-mp="31fimdp8wyfcl" />
        Placeholder — review before publication
      </span>
      <div className={onDark ? 'text-parchment' : 'text-charcoal-700'} data-id="element-556" data-mp="3u6iry4mw7r6d">{children}</div>
      {note ? <p className={`mt-3 font-sans text-[0.75rem] leading-relaxed ${onDark ? 'text-gold-200' : 'text-gold-700'}`} data-id="element-557" data-mp="30hniexfnvtp">
          {note}
        </p> : null}
    </div>;
}
export function PlaceholderPill({
  onDark
}: {
  onDark?: boolean;
}) {
  return <span className={`inline-flex items-center gap-1.5 font-sans text-micro uppercase tracking-[0.12em] px-2 py-1 border border-dashed ${onDark ? 'border-gold-600 text-gold-200' : 'border-gold-600 text-gold-700'}`} data-id="element-558" data-mp="3p9942tf5jnkn">
      <AlertTriangleIcon aria-hidden="true" className="h-3 w-3" data-id="element-559" data-mp="k9tktty7eia8" />
      Unverified
    </span>;
}